import { baseClient, authClient, getServiceURL, getURL } from '@/utils'

/**
 * DV-6593 — tipos de soporte por siteLocation (web-api v3). El catálogo y los roles salen del
 * TOKEN, no de la query: solo se manda siteLocation + lang. `lang` lo normaliza el
 * langCodeInterceptor de authClient, así que se le pasa el locale en crudo.
 */
const fetchSupportTypes = ({ siteLocation, lang }) => {
	return authClient.get(getURL('/v3/support-types', 'api'), {
		params: { siteLocation, lang }
	})
}

const fetchSupportSubjects = ({ catalogId, lang, roles }) => {
	return baseClient.get(`${getServiceURL('support')}/v1/support-types`, {
		params: {
			catalogId,
			lang,
			roleIds: roles ? roles.join(',') : null
		}
	})
}

const sendRequestBudgetUsa = ({ siteLocation, catalogId, lang, project, changeProjectName }) => {

	const url = `${getServiceURL('support')}/v1/support-request/project-budget-usa`

	return authClient.post(url,
		{
			siteLocation,
			catalogId,
			lang,
			project,
			changeProjectName,
		}
	)
}

export default {
	fetchSupportTypes,
	fetchSupportSubjects,
	sendRequestBudgetUsa
}
